<template>
	<v-card ref="list">
		<v-container
			fluid
			fill-height
			class="pa-0"
		>
			<v-progress-linear
				v-if="loading"
				indeterminate
				class="ma-0 list-loader"
			/>
			<slot name="checkbox"/>
			<v-flex
				hidden-xs-only
				xs2
				class="pa-0"
			>
				<component
					:is="image ? 'v-img' : 'div'"
					:src="image"
					:style="getBackgroundColor(imageText)"
					:height="imgHeight"
					:class="{ 'clickable': !!url }"
					class="list-img"
					@click="goToUrl"
				>
					<slot name="card-hover"/>
					<v-container
						v-if="$vuetify.breakpoint.mdAndUp"
						fill-height
						fluid
					>
						<div
							v-if="flags.length > 0"
							class="flags-container"
						>
							<v-card
								v-for="(flag, i) in flags"
								:key="i"
								flat
								:color="flag.color"
								class="ma-1 pa-1 white--text"
							>
								<div>{{ flag.text }}</div>
							</v-card>
						</div>
						<v-layout
							fill-height
							justify-center
							align-center
							ma-0
						>
							<v-flex
								xs12
								class="text-xs-center"
							>
								<span
									v-if="!image"
									class="display-1 white--text"
								>
									{{ abbreviatedTitle }}
								</span>
							</v-flex>
						</v-layout>
					</v-container>
				</component>
			</v-flex>
			<v-flex
				ref="cardText"
				xs8
				sm9
				md6
				lg7
				xl7
			>
				<v-list class="py-0">
					<v-card-title
						v-if="showHeader"
						class="pa-0"
					>
						<slot name="header"/>
					</v-card-title>
					<v-list-tile-content
						:class="{ 'clickable': !!url }"
						@click="goToUrl"
					>
						<slot name="title"/>
					</v-list-tile-content>
				</v-list>
			</v-flex>
			<slot name="additional"/>
			<slot name="actions"/>
		</v-container>
	</v-card>
</template>

<script>
import ColorHash from 'color-hash';

export default {
	props: {
		image: { default: null, type: String },
		imageText: { default: '', type: String },
		justAdded: { default: false, type: Boolean },
		flags: { default: () => [], type: Array },
		loading: { default: false, type: Boolean },
		// Use url="emit" to get an event 'url' on image click
		url: { default: null },
	},
	data() {
		return {
			colorHash: new ColorHash(),
			showHeader: false,
			imgHeight: 150,
		};
	},
	computed: {
		abbreviatedTitle() {
			if (!this.imageText) {
				return '';
			}
			const words = this.imageText.split(/\s+/);
			let letters = '';
			for (let i = 0; i < words.length; i++) {
				letters += words[i].charAt(0).toUpperCase();
			}
			if (letters.length > 3) {
				return letters.substring(0, 3);
			}
			return letters;
		},
	},
	updated() {
		if (!this.$refs.cardText) {
			this.imgHeight = 76;
			return;
		}
		if (this.$refs.cardText.clientHeight > 76) {
			this.imgHeight = this.$refs.cardText.clientHeight;
		}
		else {
			this.imgHeight = 76;
		}
	},
	created() {
		this.showHeader = !!this.$slots.header;
	},
	mounted() {
		if (this.$refs.cardText.clientHeight > 76) {
			this.imgHeight = this.$refs.cardText.clientHeight;
		}
		else {
			this.imgHeight = 76;
		}
	},
	methods: {
		getBackgroundColor(name) {
			if (!name) {
				return '';
			}
			return {
				'background-color': this.colorHash.hex(name),
				height: `${this.imgHeight}px`,
			};
		},
		goToUrl() {
			if (this.loading || !this.url) {
				return;
			}
			if (this.url === 'emit') {
				this.$emit('url');
				return;
			}
			this.$router.push(this.url);
		},
	},
};
</script>

<style scoped lang="scss">
.flags-container {
	position: absolute;
	top: 5px;
	bottom: 5px;
	left: 5px;
	right: 5px;
	display: flex;
	justify-content: flex-end;
	align-items: flex-start;
	flex-wrap: wrap;
	overflow: hidden;
}
.clickable {
	cursor: pointer;
}
.list-loader {
	position: absolute;
	top: 0;
	z-index: 0;
}
.list-img {
	position: relative;
}
</style>
